import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks } from '../data/content';
import { ReferralButton } from './ReferralButton';
import { Logo } from './Logo';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ease-smooth ${scrolled || open ? 'border-b border-hairline bg-base/85 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`} data-id="element-73" data-mp="36aiip3gt97fb">
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between gap-6 px-5 lg:h-[72px] lg:px-8" data-id="element-74" data-mp="2wm5tp3rl5925">
        <a href="#top" className="flex items-center gap-2.5" aria-label="Inicio" data-id="element-75" data-mp="2ro492eeih1ok">
          <Logo data-id="element-76" data-mp="2mmx04c0mtwgb" />
        </a>

        <nav aria-label="Principal" className="hidden xl:block" data-id="element-77" data-mp="2hnljd309mqyq">
          <ul className="flex items-center gap-1" data-id="element-78" data-mp="2hpeq0iavpb6q">
            {navLinks.map(link => <li key={link.label} data-id="element-79" data-mp="3fasxliy0zse5">
                <a href={link.href} className="block rounded-full px-3.5 py-2 text-[13.5px] text-ink-muted transition-colors duration-200 ease-smooth hover:text-white" data-id="element-80" data-mp="3ac96730nxoee">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2.5" data-id="element-81" data-mp="1wplise25eay">
          <ReferralButton location="header_login" variant="ghost" size="sm" className="hidden md:inline-flex normal-case tracking-normal font-medium" data-id="element-82" data-mp="1yae4cgtan66">
            Iniciar sesión
          </ReferralButton>
          <ReferralButton location="header" size="sm" data-id="element-83" data-mp="1wbcvnb3pr43p">
            Crear cuenta
          </ReferralButton>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="flex h-10 w-10 items-center justify-center rounded-full border border-hairline text-white transition-colors duration-200 ease-smooth hover:border-white/25 xl:hidden" data-id="element-84" data-mp="1hn8j6ov97otd">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-85" data-mp="13nqo5rrd7fbk" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-86" data-mp="13ptop5q58quj" />}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" aria-label="Navegación móvil" className="border-t border-hairline bg-base/95 px-5 pb-8 pt-4 backdrop-blur-xl xl:hidden" data-id="element-87" data-mp="2y29q9t7zvgt2">
          <ul className="flex flex-col" data-id="element-88" data-mp="hg3dvt50628l">
            {navLinks.map(link => <li key={link.label} data-id="element-89" data-mp="w47pye9jvfie">
                <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-hairline py-3.5 text-base text-ink-muted transition-colors duration-200 ease-smooth hover:text-white" data-id="element-90" data-mp="w59dhi7r5uh0">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <ReferralButton location="mobile_menu" size="lg" showArrow className="mt-6 w-full" data-id="element-91" data-mp="1f3vg51ix3tn1">
            Crear mi cuenta
          </ReferralButton>
        </nav>}
    </header>;
}